const calculateVisiblePx = (isVertical, el) => {
  const rect = el.getBoundingClientRect();
  const viewportSize = isVertical ? window.innerHeight : window.innerWidth;
  const imageSize = isVertical ? rect.bottom - rect.top : rect.right - rect.left;
  const position = {
    start: isVertical ? rect.top : rect.left,
    end: isVertical ? rect.bottom : rect.right,
  };
  const visible = {
    start: position.start >= 0 && position.start < viewportSize,
    end: position.end > 0 && position.end <= viewportSize,
  };

  if (visible.start && visible.end) {
    return imageSize;
  }
  if (visible.start) {
    return viewportSize - position.start;
  }
  if (visible.end) {
    return position.end;
  }
  if (imageSize > viewportSize && position.start < 0 && position.end > viewportSize) {
    return Math.max(0, imageSize - position.start);
  }
  return 0;
};

const calculateVisibleRowPercentage = (visiblePx, el) => Math.round((visiblePx / el.offsetWidth) * 100);

export { calculateVisiblePx, calculateVisibleRowPercentage };
